module.exports = __webpack_public_path__ + "static/media/wallet-tick-grey-bg.d896f017.svg";